/**
 * Configurações base da aplicação.
 */
const Properties = {
  STEPS: {
    IDENTIFICACAO: 0,
    INFORMACOES_COMPLEMENTARES: 1,
    RESUMO: 2,
  },
  LANGUAGE_INDEX: {
    PT_BR: 0,
    EN: 1,
  },
  BASE_URL: process.env.VUE_APP_API_BASE_URL,
  CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
  IBGE_API: "https://servicodados.ibge.gov.br/api/v1/localidades",
};

export default Properties;
